import { useTranslation } from 'react-i18next'
import styles from './sociogram-teacher-page.module.scss'
import UserIcon from '@BUP/assets/Images/Data/students_icon.svg'
import PageLayout from '@BUP/components/Layout/Page'
import TitleDashboard from '@BUP/components/Generics/TitleDashboard'
import SociogramTeacherTable from '@BUP/components/Generics/Table/SociogramTeacherTable'
import { CurrentSociogramContextProvider } from '@BUP/contexts/CurrentSociogramContext'
const SociogramTeacherPage = () => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.data.sociogram.teacher'
  })

  return (
    <PageLayout textColor='#17bebb'>
      <div className={styles.container}>
        <TitleDashboard
          icon={UserIcon}
          text={t('title')}
        />
        <p className={styles.intro_text}>{t('description')}</p>
        <div className={styles.table_wrapper}>
          <CurrentSociogramContextProvider>
            <SociogramTeacherTable />
          </CurrentSociogramContextProvider>
        </div>
      </div>
    </PageLayout>
  )
}

export default SociogramTeacherPage
